import { render, staticRenderFns } from "./ResumenProvisional.vue?vue&type=template&id=752b0754"
import script from "./ResumenProvisional.vue?vue&type=script&lang=js"
export * from "./ResumenProvisional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports